import { Button, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { ArrowLeft } from "react-feather";
const SequencerAccessDenied = ({ projectId }) => {
  const history = useHistory();
  return (
    <>
      <Button
        startIcon={<ArrowLeft />}
        variant="outlined"
        color="secondary"
        onClick={() => history.push(`/${projectId}/playlist`)}
      >
        Back to Playlist
      </Button>
      <div
        style={{
          height: "50vh",
          backgroundColor: "#1B1D28",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          <h1
            style={{
              fontSize: "60px",
              margin: "0px",
              fontFamily: "Poppins",
              color: "#6C65D9",
            }}
          >
            Access Denied
          </h1>
          <Typography>Request playlist owner to provide access</Typography>
        </div>
      </div>
    </>
  );
};

export default SequencerAccessDenied;
